import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { LoadingButton } from '@mui/lab';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const fieldLabels = [
  { key: 'shelfDisplay', label: 'قفسه' },
  { key: 'areaDisplay', label: 'ناحیه' },
  { key: 'sectionDisplay', label: 'طبقه' },
];

const InfoLine = ({ label, value }) =>
  value ? (
    <Box
      sx={{
        'display': 'flex',
        'justifyContent': 'space-between',
        'alignItems': 'center',
        'gap': 2,
        'py': 0.75,
        'borderBottom': '1px solid',
        'borderColor': 'rgba(0,0,0,0.06)',
        '&:last-of-type': { borderBottom: 'none' },
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: 'brand.grey.ternary', fontWeight: 500 }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 700, color: 'brand.grey.primary', textAlign: 'left' }}
      >
        {value}
      </Typography>
    </Box>
  ) : null;

const LocationCard = ({ title, location, actionLabel, onAction, disabled }) => (
  <Box
    sx={{
      borderRadius: '12px',
      border: '1px solid rgba(0,0,0,0.08)',
      backgroundColor: '#fff',
      boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
      minHeight: 280,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 2,
        py: 1.5,
        backgroundColor: theme => alpha(theme.palette.brand.blue.primary, 0.06),
        borderBottom: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 15,
          color: 'brand.blue.primary',
        }}
      >
        {title}
      </Typography>
    </Box>

    <Box
      sx={{
        flex: 1,
        p: 2.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: location ? 'space-between' : 'center',
        alignItems: 'center',
        gap: 2.5,
      }}
    >
      {location ? (
        <Stack spacing={0.5} sx={{ width: '100%' }}>
          <Box
            sx={{
              mb: 1.5,
              py: 1.5,
              px: 2,
              borderRadius: '10px',
              backgroundColor: theme =>
                alpha(theme.palette.brand.blue.secondary, 0.08),
              textAlign: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: 24,
                fontWeight: 800,
                color: 'brand.blue.primary',
                lineHeight: 1.3,
              }}
            >
              {[location.partDisplay, location.cellDisplay]
                .filter(Boolean)
                .join(' ')}
            </Typography>
          </Box>
          {fieldLabels.map(field => (
            <InfoLine
              key={field.key}
              label={field.label}
              value={location[field.key]}
            />
          ))}
          {location.count ? (
            <InfoLine label="تعداد" value={`x${location.count}`} />
          ) : null}
        </Stack>
      ) : (
        <Stack spacing={2} alignItems="center">
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: theme =>
                alpha(theme.palette.brand.grey.quaternary, 0.45),
            }}
          >
            <Inventory2OutlinedIcon
              sx={{ fontSize: 36, color: 'brand.grey.ternary' }}
            />
          </Box>
          <Typography
            variant="body2"
            sx={{ color: 'brand.grey.ternary', textAlign: 'center' }}
          >
            هنوز موقعیتی انتخاب نشده است
          </Typography>
          <LoadingButton
            variant="contained"
            color="primary"
            size="small"
            onClick={onAction}
            disabled={disabled}
            sx={{ minWidth: 160 }}
          >
            {actionLabel}
          </LoadingButton>
        </Stack>
      )}

      {location ? (
        <LoadingButton
          variant="outlined"
          color="primary"
          size="small"
          onClick={onAction}
          disabled={disabled}
          sx={{ alignSelf: 'stretch', minWidth: 160 }}
        >
          تغییر {title}
        </LoadingButton>
      ) : null}
    </Box>
  </Box>
);

export default LocationCard;
